module.exports = __webpack_public_path__ + "img/img-musculoskeletal.23ba8cf9.png";